module.exports = __webpack_public_path__ + "img/bbbc830.png";